const meta = document.createElement("meta")
meta.name = "naive-ui-style"
document.head.appendChild(meta)

import { maybeInitEruda } from "@/debug/eruda"

import { createApp } from "vue"
import { createPinia } from "pinia"
import { createI18n } from "vue-i18n"
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"

import App from "@/App.vue"
import router from "@/router"
import { type Locales, type MessageSchema, getI18NConf } from "@/lang/config"
import * as Sentry from "@sentry/vue";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { useNavigationStore } from "./stores/navigation"
import './assets/styles/markers.css'
import { ModelViewerElement } from '@google/model-viewer'
import PrimeVue from 'primevue/config';

// Serve Draco/KTX2 from our host so corporate VPNs blocking gstatic.com still load 3D models
const staticBase = import.meta.env.BASE_URL || '/'
ModelViewerElement.dracoDecoderLocation = `${staticBase}draco/`
ModelViewerElement.ktx2TranscoderLocation = `${staticBase}basis/`

import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';


import ToastService from "primevue/toastservice"
import Tooltip from "primevue/tooltip"

const pinia = createPinia()
// pinia.use(piniaPluginPersistedstate)

const i18n = createI18n<MessageSchema, Locales>(getI18NConf())

const app = createApp(App)

void maybeInitEruda()
router.afterEach(() => {
  void maybeInitEruda()
})

if( process.env.NODE_ENV == 'production')
{
    Sentry.init({
        app,
        dsn: "https://82351a3bf16438a3dc15293d18398de7@o4507249627299840.ingest.de.sentry.io/4507249629069392",
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
    
}




app.use(pinia)
// Global Navigation Guard
router.beforeEach((to, from, next) => {
  const navigationStore = useNavigationStore();

  // If no history, clear it (indicates direct access)
  // if (navigationStore.isDirectAccess) {
  //   navigationStore.clearHistory();
  // }

  // Add the current route to the navigation history
  navigationStore.addRoute(to.fullPath);

  next();
});

const MyAura = definePreset(Aura, {
  semantic: {
    primary: {
        50: '#ccffe5',
        100: '#9bffcf',
        200: '#00b27b',
        300: '#00df9b',
        400: '#00c98b',
        500: '#00b27b',
        600: '#008e61',
        700: '#006947',
        800: '#00472f',
        900: '#002818',
        950: '#00180d'
    }

}});


app.use(PrimeVue, {
    theme: {
        preset: MyAura,
        options: {
          darkModeSelector: false || 'none',
          cssLayer: false
      }
    }
});
app.use(ToastService)
app.directive('tooltip', Tooltip)
app.use(i18n as any)
app.use(router)
app.component('QuillEditor', QuillEditor)
app.component('vue-cal', VueCal);
// Make sure Vue knows about custom elements
app.config.compilerOptions.isCustomElement = (tag) => tag.includes('model-viewer')

app.mount("#app")
// myUndefinedFunction();
